module.exports = __webpack_public_path__ + "img/value_icon3.22b8d25b.png";